class AssertionError extends Error {}

const assert = (assertion, message) => {
	console.assert(assertion, message);
	if (assertion !== true)
		throw new AssertionError(message);
}

export default assert;